import { client } from '@/common-utils/libraries/axios/axios';
import { DOWNLOAD_CODES } from '../apiUrls';
const mutationCreateDownloadCode = (onSuccess, onError) => {
    return {
        mutationFn: ({ downloadCodeDataToSend }) => {
            return client.post(DOWNLOAD_CODES.CREATE.url, downloadCodeDataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateDownloadCode;